import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

@Component({
    mixins: [ProjectMixin],
})
export default class ProjectSelect extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop({ default: false }) outlined!: boolean
    @Prop({ default: false }) dense!: boolean
    @Prop({ default: false }) dark!: boolean
    @Prop({ required: true }) permission!: string

    id: any = null

    get project() {
        return this.$route.params.type == 'p'
            ? this.$store.getters.project(this.$route.params.id)
            : null
    }

    get group() {
        return this.$route.params.type == 'g'
            ? this.$store.getters.group(this.$route.params.id)
            : null
    }

    get projects(): Array<any> {
        return Object.values(this.$store.getters.projects).filter((project: any) => {
            return this.hasPermission(project.attributes.permissions, this.permission)
        })
    }

    mounted() {
        this.id = this.projects[0]?.id
        this.$emit('setProject', this.id)
    }
}
